import triggerTracking from '@blueprint/tracking';

const EVENT = 'GAEvent';
const CATEGORY = 'homepage';

export const trackAgentValuationCTA = () => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: 'get_agent_valuation'
    });
};
